import { render, staticRenderFns } from "./qyxjhinfo.vue?vue&type=template&id=6f0315ed&scoped=true"
import script from "./qyxjhinfo.vue?vue&type=script&lang=js"
export * from "./qyxjhinfo.vue?vue&type=script&lang=js"
import style0 from "./qyxjhinfo.vue?vue&type=style&index=0&id=6f0315ed&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0315ed",
  null
  
)

export default component.exports